import React from 'react';
import { useSearchParams } from 'react-router';
import axios from 'axios';
import { useAuth } from '../AuthContext';
import { apiHost } from '../../../shared/api/helpers';
import { ThemeToggle } from '../../../shared/ui/ThemeToggle';
import { beginImpersonationSession } from '../../../shared/api/authStorage';

const ImpersonatePage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const auth = useAuth();
    const [message, setMessage] = React.useState('사용자 전환 중입니다…');

    React.useEffect(() => {
        beginImpersonationSession();
        if (!token) {
            setMessage('토큰이 없습니다.');
            return;
        }

        let active = true;
        axios.post(`${apiHost}/api/account/impersonate/exchange/`, { token })
            .then((response) => {
                if (!active) return;
                const data = response.data;
                if (!data?.access || !data?.refresh) {
                    throw new Error(data?.message || '사용자 전환에 실패했습니다.');
                }
                auth.loginImpersonation({ access: data.access, refresh: data.refresh });
                window.location.replace('/');
            })
            .catch((error) => {
                if (!active) return;
                const msg = error.response?.data?.message
                    || error.message
                    || '사용자 전환 중 오류가 발생했습니다.';
                setMessage(msg);
            });
        return () => { active = false; };
    }, [token]);

    return (
        <div className="auth-shell">
            <div className="auth-theme"><ThemeToggle /></div>
            <aside className="auth-aside">
                <div className="auth-brand"><span className="brand-dot" aria-hidden="true" />nprice</div>
                <p className="auth-lede">가격 비교 · 조정 · 작업이력</p>
            </aside>
            <div className="auth-panel">
                <div className="alert alert-info" role="alert">
                    {message}
                </div>
            </div>
        </div>
    );
};

export default ImpersonatePage;
